export default {
	meta: {
		title: 'Accès refusé',
		description: 'Vous n’avez pas les droits pour accéder à cette page.'
	},
	code: '401',
	error: 'Accès refusé',
	message: 'Vous n’avez pas les droits pour accéder à cette page.',
	cta: 'Retour à la page d’accueil'
};
